import { useQuery } from "@tanstack/react-query";
import { acessoService } from "@/core/services/acessoService";

/**
 * F6-14 (revisão 21/07/2026): expõe o modo de dados do módulo
 * (compartilhado/individual — só importa com 2+ ministérios responsáveis,
 * migration 0030/0048) e, quando individual, por quais ministérios a pessoa
 * atual gerencia especificamente esse módulo.
 *
 * Usado em dois lugares: (1) para restringir a lista de "qualquer
 * ministério" no formulário de criar/editar a só os ministérios que a
 * pessoa gerencia (em vez de todos os responsáveis pelo módulo), e (2) para
 * esconder botões de editar/excluir que a RLS recusaria — mesma defesa em
 * profundidade do F4-10 (evita botão morto, que parece clicável mas não
 * redireciona/não salva).
 */
export function useGestaoModulo(moduloCodigo: "eventos" | "reservas") {
  const modoDadosQuery = useQuery({
    queryKey: ["modo-dados-modulo", moduloCodigo],
    queryFn: () => acessoService.modoDadosModulo(moduloCodigo),
  });
  const ministeriosGestaoQuery = useQuery({
    queryKey: ["ministerios-gestao-modulo", moduloCodigo],
    queryFn: () => acessoService.minhasMinisteriosGestaoModulo(moduloCodigo),
  });

  return {
    modoDados: modoDadosQuery.data ?? "compartilhado",
    ministeriosGestao: ministeriosGestaoQuery.data ?? [],
    carregando: modoDadosQuery.isLoading || ministeriosGestaoQuery.isLoading,
  };
}
